import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import { find, get, startCase } from 'lodash';

import { ILoanAccountActivity } from '../../../interfaces';
import { OptionsStoreClass } from '../../../stores';

import LoanAccountActivity from './LoanAccountActivity';

interface IProps {
  activity: ILoanAccountActivity;
}

interface IInjected extends IProps {
  OptionsStore: OptionsStoreClass;
}

/**
 * Recorded whenever one of the account's three owners changes, unassignment included. The names come
 * off the snapshot rather than the account, so the entry still reads correctly once someone has left
 * the funder and the account has moved on.
 */
@inject('OptionsStore')
@autoBindMethods
@observer
class OwnerAssigned extends Component<IProps> {
  private get injected () {
    return this.props as IInjected;
  }

  // The activity snapshots the position as a raw enum value; its label comes from the same /options/
  // list the rest of the lending UI labels enums from. c.f. PaymentLogged and its payment type.
  // Title cased for a heading, the list being sentence cased for a form label ("Primary owner").
  private get ownerType () {
    const { owner_type } = this.props.activity.data
      , { OptionsStore } = this.injected
      , option = find(OptionsStore.loanAccountOwnerTypeOptions, { value: owner_type })
      ;

    return startCase(get(option, 'name', owner_type));
  }

  public render () {
    const { data } = this.props.activity
      // The same entry records an unassignment, which has a previous owner and no new one
      , isUnassignment = !data.owner_name
      , activityBody = (
        <div>
          <h3>{this.ownerType} {isUnassignment ? 'Unassigned' : 'Assigned'}</h3>
          {!isUnassignment && <p><span className='status'>Owner:</span> {data.owner_name}</p>}
          {/* Left off when there was no one in the position before, which is most first assignments */}
          {!!data.previous_owner_name &&
            <p><span className='status'>Previously:</span> {data.previous_owner_name}</p>}
        </div>
      )
      ;

    // Passed explicitly rather than spread: a spread would let a prop added upstream override the
    // dot and icon this component picked, and the failure would be a wrong icon rather than an error.
    return (
      <LoanAccountActivity
        activity={this.props.activity}
        activity_body={activityBody}
        dot='icon'
        icon='user'
      />
    );
  }
}

export default OwnerAssigned;
